import { render, staticRenderFns } from "./process-item.vue?vue&type=template&id=04f5ee2a&"
import script from "./process-item.vue?vue&type=script&lang=js&"
export * from "./process-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports